import { State } from 'model/State';

/**
 * Returns the quote number being edited, or null if no quote is being edited.
 */
export default (state: State) =>
  state.cart.payload.ifSuccess((cart) => cart && cart.inEditMode && cart.quoteNumber) || null;
